export default __webpack_public_path__ + "static/media/heli.d1951a4c.jpg";